import * as types from "./dashboardTypes";

//FOR FETCHING DASHBOARD
export const fetchDashboardRequest = () => (
    {
    type: types.FETCH_DASHBOARD_REQUEST,
});

export const fetchDashboardSuccess = (data) => ({
    type: types.FETCH_DASHBOARD_SUCCESS,
    payload: data,
});

export const fetchDashboardFailure = (error) => ({
    type: types.FETCH_DASHBOARD_FAILURE,
    payload: error,
});



